import { render, staticRenderFns } from "./ChamadoComentario.vue?vue&type=template&id=b20c9606&"
import script from "./ChamadoComentario.vue?vue&type=script&lang=js&"
export * from "./ChamadoComentario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports